module.exports = __webpack_public_path__ + "img/GDQ-matcirkel_90.78bd0374.gif";